module.exports = __webpack_public_path__ + "img/book-medical.bea22f64.svg";